import styled from 'styled-components';
import * as FiIcons from 'react-icons/fi';

export const EnrollmentUploadContainer = styled.form`
  min-width: 100%;
  min-height: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
`;

export const EnrollmentUploadHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const EnrollmentUploadBodyContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const EnrollmentUploadBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
  margin-top: 2%;
  height: 100%;
  padding: 10px;
  padding-left: 25px;
  border-radius: 30px;
`;

export const EnrollmentUploadFooter = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #fff;
  justify-content: space-between;
  padding-bottom: 10px;
`;

export const EnrollmentUploadTitle = styled.p`
  font: normal normal bold 20px/31px Biotif;
`;

export const EnrollmentUploadIcon = styled.div`
  align-self: center;
`;
export const EnrollmentUploadSubTitleContainer = styled.div`
  display: flex;
`;

export const EnrollmentUploadSubTitle = styled.h4`
  display: flex;
`;

export const CloseIcon = styled.img`
  width: 14px;
  height: auto;
  align-self: flex-end;
`;

export const EnrollmentUploadFormContainer = styled.div`
  display: 'flex';
  flex-direction: column;
`;

export const EnrollmentUploadFileDrop = styled.input`
  font: normal normal bold 20px/31px Biotif;
  text-align: center;
  background: #4a4ba9;
  border-radius: 7px;
  padding-top: 5px;
  color: white;
  width: 233px;
  height: 37px;
  ::-webkit-file-upload-button {
    visibility: hidden;
  }
  ::before {
    content: 'Upload Document';
    font: normal normal bold 20px/31px Biotif;
    color: #fff;
    font-size: 14px;
    padding-left: 35px;
    text-transform: uppercase;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.8;
    transition: 1s;
  }
`;

export const TrashIcon = styled(FiIcons.FiTrash2)`
  pointer-events: none;
`;

export const EnrollmentUploadListContainer = styled.div``;

export const EnrollmentUploadListTitle = styled.h3``;

export const EnrollmentUploadList = styled.div`
  display: 'flex';
  background: #f3f4f8;
  display: flex;
  align-self: center;
  border-radius: 10px;
`;

export const EnrollmentUploadListRemove = styled.div`
  padding-top: 15px;
  padding-right: 30px;
  &:hover {
    cursor: pointer;
  }
`;
